<script setup lang="ts">
//@TODO 自定义组件，会导致内置校验失效
import VueForm from '@lljj/vue3-form-element';
import { FormSchema } from './type.d';
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
const { t: $t, te } = useI18n();

const $props = defineProps<{
  schema?: Object;
  uiSchema?: Object;
  modelValue?: Object;
  errorSchema?: {
    [key: string]: {
      required?: string;
    };
  };
  customRule?: (params: { field: string; value: any; rootFormData: any; callback: (error?: string) => void }) => void;
}>();

const $emit = defineEmits<{
  (event: 'change', value: boolean): void;
  (event: 'update', value: boolean): void;
  (event: 'update:modelValue', value: boolean): void;
}>();

const formRef = ref();
const formData = ref($props.modelValue);

const schema = computed(() => {
  const schema = {} as FormSchema;
  for (let key in $props.schema) {
    if (key === 'title' || key === 'description' || key.startsWith('err:')) {
      // @ts-ignore
      schema[key] = $t($props.schema[key], {}, '');
    } else {
      if (key === 'properties') {
        const properties: { [k: string]: { [kk: string]: unknown } } = {};
        // @ts-ignore
        for (let k in $props.schema[key]) {
          // @ts-ignore
          properties[k] = {};
          // @ts-ignore
          for (let kk in $props.schema[key][k]) {
            // @ts-ignore
            properties[k][kk] = properties[k][kk] || {};
            if (kk === 'title' || kk === 'description' || kk === 'ui:placeholder') {
              // @ts-ignore - translate if key exists, otherwise use as-is (for pre-translated values)
              const val = $props.schema[key][k][kk];
              properties[k][kk] = te(val) ? $t(val) : val;
            // @ts-ignore
            } else if (kk === 'enumNames' && Array.isArray($props.schema[key][k][kk])) {
              // @ts-ignore - Translate enumNames: only translate if key exists, otherwise keep original value
              properties[k][kk] = $props.schema[key][k][kk].map((n: string) => te(n) ? $t(n) : n);
            } else if (kk === 'ui:options') {
              // Preserve all ui:options keys; only translate placeholder text.
              // @ts-ignore
              const opts = { ...$props.schema[key][k][kk] };
              if (opts.placeholder) opts.placeholder = $t(opts.placeholder, {}, '');
              if (opts.inputOptions?.placeholder) opts.inputOptions = { ...opts.inputOptions, placeholder: $t(opts.inputOptions.placeholder, {}, '') };
              properties[k][kk] = opts;
            } else {
              // @ts-ignore
              properties[k][kk] = $props.schema[key][k][kk];
            }
          }
        }
        schema['properties'] = properties as FormSchema['properties'];
      } else {
        // @ts-ignore
        schema[key] = $props.schema[key];
      }
    }
  }

  return schema as FormSchema;
});

const formProps = {
  labelPosition: 'left',
  labelWidth: '50%',
  labelSuffix: '',
  isMiniDes: false,
};

const handleChange = ({ newValue }: any) => {
  $emit('update:modelValue', newValue);
  $emit('update', newValue);
};

defineExpose({
  formRef,
});
</script>
<template>
  <div class="schema-form">
    <VueForm
      ref="formRef"
      :schema="schema"
      v-model="formData"
      :formFooter="{ show: false }"
      :formProps="formProps"
      :uiSchema="$props.uiSchema"
      :errorSchema="$props.errorSchema"
      :custom-rule="$props.customRule"
      @change="handleChange"
    />
  </div>
</template>
<style lang="scss">
.schema-form {
  .el-form-item {
    min-height: 50px;
    border-radius: var(--radius-10);
    background: var(--color-schema-form-item-bg);
    padding: 0 10px;
    margin-bottom: 5px;
  }
  .el-form-item__label {
    margin-top: 10px;
  }
  .el-form-item__content {
    display: flex;
    justify-content: flex-end;
    margin-right: 0 !important;
  }
  .layoutColumn.layoutColumn-1 .fieldGroupWrap_box > .genFormItem {
    // padding-right: 10px;
    .el-switch {
      margin-right: 10px;
    }
  }

  /* 隐藏formFooter */
  .fieldGroupWrap_box .el-form-item:last-child {
    display: none;
  }
}
</style>
<style lang="scss">
.genFromComponent {
  .fieldGroupWrap_title {
    @apply text-sm font-medium mb-0;
  }
  .fieldGroupWrap_des {
    display: none;
  }
  .genFormLabel,
  .genFromWidget_des {
    user-select: none;
  }
  // .genFormItemRequired {
  //   position: relative;
  //   :before {
  //     position: absolute;
  //     right: 0;
  //   }
  // }
  @media (min-width: 768px) {
    .genFormItem {
      padding: 6px 0 10px 0;
      .genFormLabel {
        position: absolute;
        font-size: var(--fs-14);
        width: 100%;
        top: 0;
        color: var(--color-schema-form-label);
        font-weight: 500;
        display: flex;
        &::before {
          order: 2;
        }
      }
      .el-form-item__content {
        position: static;
      }
    }
    .genFromWidget_des {
      position: absolute;
      left: 0.5rem;
      top: 25px;
      line-height: 1 !important;
      font-size: var(--fs-10);
      max-width: 300px;
      overflow: hidden;
      color: var(--color-schema-form-description);
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .genFormItem {
    @apply md:flex items-center mt-0 relative px-2 box-border overflow-x-hidden mb-1 rounded-xl;
    // z-index: 0 !important;
    background-color: var(--color-schema-form-item-bg);
    padding-top: 0;
    padding-bottom: 0;
    .el-form-item__label {
      @apply md:flex block;
      width: 300px !important;
    }
    .el-form-item__content {
      @apply mr-2 md:flex block justify-end;

      .el-input,
      .el-input-number,
      .el-select {
        @apply md:w-full md:h-[50px];
      }
      .el-textarea__inner {
        @apply h-full;
      }
      .el-date-editor.el-input {
        @apply w-full md:w-[320px];
      }
    }
    .formItemErrorBox {
      @apply h-4 absolute left-2 z-10 top-auto pt-0;
      // bottom: 0.3rem;
      top: 28px;
      font-size: var(--fs-10);
    }
    &.el-form-item.is-error {
      .genFromWidget_des {
        display: none;
      }
      .el-input__wrapper {
        box-shadow: 0 0 0 1.5px var(--el-color-danger) inset;
      }
    }
    .el-textarea__inner {
      font-size: var(--fs-20);
    }
    .el-input {
      .el-input__inner {
        text-align: left;
        font-size: var(--fs-20);
      }
      .el-input__suffix-inner > :first-child {
        margin-left: 0;
        user-select: none;
      }
    }
  }
}
</style>
